import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from "jsx/elements/inputs/Checkbox";
import YesNo from "components/Display/YesNo";
import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";
import TransactionKey from "../Display/TransactionKey";
import CostCalculatedFor from "../Display/CostCalculatedFor";
import RecordNumber from "../Display/RecordNumber";


class CostResultTable extends React.Component {

  state = {
    showPayments : false
  };

  constructor(props){
    super(props);
    this.showshowPaymentsClick = this.showshowPaymentsClick.bind(this);
  }

  showshowPaymentsClick(){
    //console.debug("This:");
    this.setState({ showPayments: !this.state.showPayments });
  };


  render() {
    if (!this.props.data.costs){
      return (
        <div/>
      );
    }
    let costs = this.props.data.costs;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="11" className="text-left">
              <span className="calc-setting-table-header">Kostnaður sem var notaður í útreikningum&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input id="checkCostid1" type="checkbox" checked={this.state.showPayments} onChange={this.showshowPaymentsClick}/><label className="calc-small-checkbox-label" htmlFor="checkCostid1" >Sýna greiðslur</label>
            </th>
          </tr>
          <tr>
            <th className="text-left">Reiknað f.</th>
            <th className="text-left">Færsl.nr.</th>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Dagsetning</th>
            <th className="text-right">Upphæð</th>
            <th className="text-right">VSK</th>
            <th className="text-right">VSK %</th>

            <th className="text-right">Drv</th>
            <th className="text-right">Hst.Drv</th>
            <th className="text-right">FTS</th>

            <th className="text-right">Gen</th>

          </tr>
          </thead>
          <tbody>
          {costs.map((item,i) => {
            let paymentContent = this.state.showPayments ? (
              <tr key={i}>
                <td colSpan="4" className="text-right"><b>Greitt:</b></td>
                <td className="text-right"><Amount data={item.paymentAmount}/></td>
                <td className="text-right"><Amount data={item.vatPaidAmount}/></td>
                <td>&nbsp;</td>
                <td className="text-right"><Amount data={item.penaltyInterestPaidAmount}/></td>
                <td className="text-right"><Amount data={item.capitalizedPenaltyInterestPaidAmount}/></td>
                <td className="text-right"><Amount data={item.capitalGainsTaxPaidAmount}/></td>
                <td>&nbsp;</td>
              </tr>
            ) : null;

            return([
              <tr key={i + "inner"}>
                <td className="text-left"><CostCalculatedFor data={item.calculatedFor}/></td>
                <td className="text-left"><RecordNumber data={item.transactionNumber}/></td>
                <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                <td className="text-right"><Date data={item.dueDate}/></td>
                <td className="text-right"><Amount data={item.amount}/></td>
                <td className="text-right"><Amount data={item.vatAmount}/></td>
                <td className="text-right"><Amount data={item.vatRate}/></td>
                <td className="text-right"><Amount data={item.penaltyInterestAmount}/></td>
                <td className="text-right"><Amount data={item.capitalizedPenaltyInterestAmount}/></td>
                <td className="text-right"><Amount data={item.capitalGainsTaxAmount}/></td>
                <td className="text-right"><YesNo data={item.generated}/></td>
              </tr>,
                paymentContent]
            )
          })}

          </tbody>
        </table>
      </div>
    );
  }
}

CostResultTable.propTypes = {
  data: PropTypes.object,
};



export default CostResultTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/CostResultTable.js